export enum TradingPartnerType {
  Customer = "CUSTOMER",
  Vendor = "VENDOR",
  Employee = "EMPLOYEE"
}